import { atom } from 'jotai';
import { loadable } from 'jotai/utils';

import { SignUpSettingsResponse } from 'src/types/register';

// register/apis는 auth/modal 체인을 끌어와 Jest에서 TDZ를 유발할 수 있어
// atom read 시점에만 동적으로 로드한다.
export const fetchSignUpSettingsAtom = atom<
  Promise<SignUpSettingsResponse> | SignUpSettingsResponse
>(async () => {
  const { getSignUpSettingsAPI } = await import('./apis');
  const { data } = await getSignUpSettingsAPI();
  return data;
});

export const signUpSettingsLoadableAtom = loadable(fetchSignUpSettingsAtom);
